// extracted by mini-css-extract-plugin
export var drawerPaper = "_2h-0";
export var itemImage = "_2h-1";